import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import {
  DeleteMainServices,
  EditMainServices,
  GetMainServices,
  ManageMainServices,
} from "./actions";
import { GetMediaTypes } from "../media_list/actions";

const MainServices = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    name: Yup.string().trim().required("required"),
    banner_description: Yup.string().trim().required("required"),
    description: Yup.string().trim().required("required"),
    // image: Yup.string().trim().required(false),
    banner_image: Yup.string().trim().required("required"),
  });

  const GetData = ({ tableName = null, type = null }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetMainServices({
        rowsPerPage,
        page,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setTotalData(data?.count);
            setarray([
              {
                failed: "id",
                type: inputType.text,
                title: "id",
                placeholder: "",
                fullwidth: true,
                customdesign: { display: "none" },
              },

              {
                failed: "name",
                type: inputType.text,
                title: "Name",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "title",
                type: inputType.text,
                title: "Title",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "banner_description",
                type: inputType.text,
                title: "Banner Description",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "description",
                type: inputType.text,
                title: "Description",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "image",
                type: inputType.image,
                title: "Image",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
              {
                failed: "banner_image",
                type: inputType.image,
                title: "Banner Image",
                placeholder: "",
                fullwidth: true,
                customdesign: { width: "100%" },
              },
            ]);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
    // dispatch(
    //   GetMediaTypes({
    //     callback: (data) => {
    //       if (isValidArray(data?.data)) {
    //         setMediaTypes(data?.data);
    //         if (array.length == 0) {
    //           setarray([
    //             {
    //               failed: "id",
    //               type: inputType.text,
    //               title: "id",
    //               placeholder: "",
    //               fullwidth: true,
    //               customdesign: { display: "none" },
    //             },

    //             {
    //               failed: "name",
    //               type: inputType.text,
    //               title: "Name",
    //               placeholder: "",
    //               fullwidth: true,
    //               customdesign: { width: "100%" },
    //             },
    //             {
    //               failed: "banner_description",
    //               type: inputType.text,
    //               title: "Banner Description",
    //               placeholder: "",
    //               fullwidth: true,
    //               customdesign: { width: "100%" },
    //             },
    //             {
    //               failed: "description",
    //               type: inputType.text,
    //               title: "Description",
    //               placeholder: "",
    //               fullwidth: true,
    //               customdesign: { width: "100%" },
    //             },
    //             {
    //               failed: "image",
    //               type: inputType.image,
    //               title: "Image",
    //               placeholder: "",
    //               fullwidth: true,
    //               customdesign: { width: "100%" },
    //             },
    //             {
    //               failed: "banner_image",
    //               type: inputType.image,
    //               title: "Banner Image",
    //               placeholder: "",
    //               fullwidth: true,
    //               customdesign: { width: "100%" },
    //             },
    //           ]);
    //         }
    //       } else {
    //         setMediaTypes([]);
    //       }
    //     },
    //   })
    // );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "name" },
    { type: columntype.text, name: "title" },
    { type: columntype.text, name: "banner_description" },
    { type: columntype.image, name: "image" },
    { type: columntype.text, name: "description" },
    { type: columntype.image, name: "banner_image" },
    { type: columntype.switch, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: false,
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
      withSort: false,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
      withSort: false,
    },
    {
      id: "banner_description",
      numeric: false,
      disablePadding: false,
      label: "Banner Description",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: true,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      withSort: false,
    },

    {
      id: "banner_image",
      numeric: false,
      disablePadding: false,
      label: "Banner Image",
      withSort: true,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is active",
      withSort: true,
    },
    (dataPrivileges["27"]?.access_edit == 1 ||
      dataPrivileges["27"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges["27"]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete "${row?.name ?? ""}"?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteMainServices({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges["27"]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditMainServices({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        handleSearch={(event) => setSearch(event.target.value)} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(valueId) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteMainServices({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: valueId,
                    })
                  ),

                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["27"]?.access_write === 1}
        withDeleteItem={dataPrivileges["27"]?.access_delete === 1}
        withEditItem={dataPrivileges["27"]?.access_edit === 1}
        withPagination={true}
        withSearch={false}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"MainServices"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new MainServices slide"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onSubmit={(valuess) => {
            dispatch(
              ManageMainServices({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default MainServices;
